import { Link } from "react-router-dom";

// images
import ArrowIconImage from "../../images/pages/forgotpwpage/arrow-icon.svg";

function ResetSuccessfulPage() {
    return (
        <div className="ResetSuccessfulPage">
            <div className="Title">Reset successful</div>
            <div className="Description">
                You can now log in to your account 
            </div>
            <Link className="LinkToSignInPage" to="/sign-in">
                Login Now
                <img src={ArrowIconImage} alt="link to signin page" />
            </Link>
        </div>
    );
}

export default ResetSuccessfulPage;